/* Candidate asset assets/pinterest-pilot-tracking.js; not deployed by this file. */
(function () {
  'use strict';
  if (window.InnocentiaPinterestPilot) return;
  var KEY = 'innocentia_pinterest_pilot_v1';
  var CAMPAIGN = 'pilot_20260907';
  var TAG = 'G-KMGP3LF90Q';
  var MAX_AGE = 30 * 24 * 60 * 60 * 1000;
  var lastLink = null;
  var lastAt = 0;
  var ownTagLoaded = false;
  var ownTag = null;

  function allowed() {
    try {
      if (localStorage.getItem('cookie_consent') === 'declined') return false;
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      return !!(privacy && typeof privacy.analyticsProcessingAllowed === 'function' &&
        privacy.analyticsProcessingAllowed());
    } catch (e) { return false; }
  }
  function valid(touch) {
    return touch && touch.utm_source === 'pinterest' && touch.utm_campaign === CAMPAIGN &&
      /^(product|article)_(0[1-9]|1[0-2])$/.test(touch.utm_content) &&
      Date.now() - touch.captured_at >= 0 && Date.now() - touch.captured_at <= MAX_AGE;
  }
  function read() {
    if (!allowed()) return null;
    try {
      var touch = JSON.parse(sessionStorage.getItem(KEY));
      if (valid(touch)) return touch;
      sessionStorage.removeItem(KEY);
    } catch (e) {}
    return null;
  }
  function capture() {
    if (!allowed()) {
      try { sessionStorage.removeItem(KEY); } catch (e) {}
      return;
    }
    var params = new URLSearchParams(window.location.search);
    var source = (params.get('utm_source') || '').toLowerCase();
    var campaign = params.get('utm_campaign') || '';
    var content = params.get('utm_content') || '';
    var touch = { utm_source: source, utm_medium: params.get('utm_medium') || 'organic',
      utm_campaign: campaign, utm_content: content, captured_at: Date.now() };
    try {
      if (valid(touch)) sessionStorage.setItem(KEY, JSON.stringify(touch));
      else if (source || campaign || params.get('utm_medium')) sessionStorage.removeItem(KEY);
    } catch (e) {}
  }
  function campaignFields(qa) {
    if (qa) return { campaign_source: 'pinterest_qa', campaign_medium: 'qa',
      campaign_name: 'pilot_20260907_qa', campaign_content: 'retailer_click_qa' };
    var touch = read();
    return touch ? { campaign_source: touch.utm_source, campaign_medium: touch.utm_medium,
      campaign_name: touch.utm_campaign, campaign_content: touch.utm_content } : {};
  }
  function sender(campaign) {
    if (typeof window.gtag === 'function') return window.gtag;
    if (!ownTagLoaded) {
      ownTagLoaded = true;
      window.innocentiaPilotDataLayer = window.innocentiaPilotDataLayer || [];
      ownTag = function () { window.innocentiaPilotDataLayer.push(arguments); };
      ownTag('consent', 'default', { analytics_storage: 'granted', ad_storage: 'denied',
        ad_user_data: 'denied', ad_personalization: 'denied' });
      ownTag('js', new Date());
      ownTag('config', TAG, Object.assign({ send_page_view: false, allow_google_signals: false,
        allow_ad_personalization_signals: false }, campaign));
      var script = document.createElement('script');
      script.async = true;
      script.src = 'https://www.googletagmanager.com/gtag/js?id=' + TAG + '&l=innocentiaPilotDataLayer';
      document.head.appendChild(script);
    }
    return ownTag;
  }
  function hash(value) {
    var result = 2166136261;
    for (var i = 0; i < value.length; i += 1) {
      result ^= value.charCodeAt(i);
      result = Math.imul(result, 16777619);
    }
    return 'r' + (result >>> 0).toString(16);
  }
  function trackClick(event) {
    if (event.isTrusted === false || !allowed() || !/\/pages\/retailers\/?$/.test(window.location.pathname)) return;
    var link = event.target && event.target.closest && event.target.closest('#MainContent table.results tbody.list a');
    if (!link) return;
    var url;
    try { url = new URL(link.getAttribute('href').trim(), window.location.origin); } catch (e) { return; }
    var kind = url.protocol === 'tel:' ? 'phone' : url.protocol === 'mailto:' ? 'email' : 'website';
    if (kind === 'website' && (!/^https?:$/.test(url.protocol) || url.hostname === window.location.hostname)) return;
    if (lastLink === link && Date.now() - lastAt < 1000) return;
    lastLink = link;
    lastAt = Date.now();
    var row = link.closest('tr');
    var client = row && row.querySelector('[data-label="Client"]');
    var country = row && row.querySelector('[data-label="Country"]');
    var identity = (client ? client.textContent.trim() : '') + '|' + (country ? country.textContent.trim() : '');
    var qa = new URLSearchParams(window.location.search).get('innocentia_pilot_qa') === '1';
    var campaign = campaignFields(qa);
    sender(campaign)('event', qa ? 'retailer_click_qa' : 'retailer_click', Object.assign({ send_to: TAG, retailer_key: hash(identity),
      contact_channel: kind, page_location: window.location.origin + window.location.pathname,
      page_referrer: '', transport_type: 'beacon' }, campaign, qa ? { debug_mode: true } : {}));
  }
  window.InnocentiaPinterestPilot = { read: read };
  function consentChanged() {
    if (ownTag) ownTag('consent', 'update', { analytics_storage: allowed() ? 'granted' : 'denied' });
    capture();
  }
  document.addEventListener('cookieConsentSet', consentChanged);
  document.addEventListener('visitorConsentCollected', consentChanged);
  document.addEventListener('click', trackClick);
  capture();
  var shopify = window.Shopify;
  var privacy = shopify && shopify.customerPrivacy;
  if ((!privacy || typeof privacy.analyticsProcessingAllowed !== 'function') &&
      shopify && typeof shopify.loadFeatures === 'function') {
    try {
      shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
        if (!error) consentChanged();
      });
    } catch (e) {}
  }
})();
